import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  PageContainer, 
  SectionContainer, 
  CenteredFlexContainer, 
  SectionHeader, 
  BodyText, 
  PrimaryButton 
} from '../styles/components';
import { layoutMixins } from '../styles/mixins';
import { borderRadius } from '../styles/constants';

function OurStory() {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <SectionContainer>
        <CenteredFlexContainer>
          <Box 
            component="img"
            src="/hot_air_balloon.jpg"
            alt="Sam and Alexa in a hot air balloon"
            sx={layoutMixins.responsiveImage}
          />
        </CenteredFlexContainer>

        {/* Our Story header section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: borderRadius.medium,
          mb: 4 
        }}>
          <SectionHeader>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              💕 OUR STORY
            </Typography>
          </SectionHeader>

          <BodyText>
            Alexa and Sam met in Boulder, Colorado, when Alexa was a senior at CU Boulder and Sam had just moved from Pittsburgh to pursue career opportunities in software engineering.
          </BodyText>

          <BodyText>
            Over time, they slowly became friends, drawn together by a shared sense of humor and a surprising number of common interests. During that time, Alexa introduced Sam to the beauty of the outdoors, while Sam (literally) helped Alexa conquer math so she could pass her chemistry final—with a solid B- and a big sigh of relief.
          </BodyText>

          <BodyText>
            To the surprise of no one around them, their friendship blossomed into something more.
          </BodyText>

          <BodyText>
            Since then, they've circumnavigated the globe together, rebuilt a home (ask Sam about his retaining wall), and raised two very cute dogs (shout out to the Haze Beast & Rocket Boi!). Along the way, Alexa has shown Sam how to take life just a touch less seriously, while Sam has been a steady hand, helping Alexa build a career she loves. They've become each other's biggest fans, anchors, and adventure partners.
          </BodyText>

          <BodyText sx={{ mb: 0 }}>
            Now, nearly eight years later, they're getting married—excited, grateful, and more in love than ever as they take this next step together.
          </BodyText>
        </Box>

        <CenteredFlexContainer>
          <Box 
            component="img"
            src="/hot_air_balloon_prompose.JPG"
            alt="Sam and Alexa in a hot air balloon post prompose"
            sx={layoutMixins.responsiveImage}
          />
        </CenteredFlexContainer>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <PrimaryButton
            variant="contained"
            onClick={() => navigate('/rsvp')}
            sx={{
              mt: 3,
              mb: 4,
              px: 8,
            }}
          >
            RSVP
          </PrimaryButton>
        </Box>
      </SectionContainer>
    </PageContainer>
  );
}

export default OurStory;
